module.exports = "/assets/dc14820d72a4ec7f08734c388d8bb9db.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/SA.png
// module id = 2935
// module chunks = 0